export default {
  title: '兌換統計',
  exchangeTime: '兌換時間',
  startDate: '開始時間',
  endDate: '結束時間',
  totalPointsConsumed: '消耗積分總量',
  totalGiftsExchanged: '累計兌換禮品數',
  unitGifts: '件',
  totalOrders: '兌換訂單總數',
  unitOrders: '單',
  popularRankTitle: '熱門兌換禮品排行',
  rankNo: '排名',
  giftDetail: '禮品詳情',
  exchangeQty: '兌換數量',
  popularity: '熱度占比',
  trendTitle: '近7天兌換情況',
  trendSeries: '兌換數量',
  rangeLimitTip: '兌換時間最多支持一年，下面數據根據查詢條件變化',
};
